import { accountQueries } from '../queries/account.queries';
import { appQueryClient } from '~/adapters/reactQuery';

export const accountKeys = {
  allFetchCurrentAccount: () => ['fetchCurrentAccount'],
  fetchCurrentAccount: () => [...accountKeys.allFetchCurrentAccount()],
};

export const fetchCurrentAccountQuery = () => {
  return appQueryClient.fetchQuery({
    queryKey: accountKeys.fetchCurrentAccount(),
    queryFn: () => accountQueries.fetchCurrentAccount(),
    // 30 minutes
    staleTime: 30 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
  });
};
